﻿import { Coordinate } from "ol/coordinate";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import MultiPoint from "ol/geom/MultiPoint";

import { BaseGeometryExtension, GeometryExtensionUtilities } from "./BaseGeometryExtension";
import DateLineUtilities from "../../utilities/DateLineUtilities";

export class MultiPointExtension extends BaseGeometryExtension<MultiPoint> {

    public getCoordinates() {
        return this.geometry.getCoordinates();
    }

    public setCoordinates(coordinates: Coordinate[]): void {
        this.geometry.setCoordinates(coordinates);
    }

    public intersectsExtent(extent: [number, number, number, number]) {
        return this.geometry.intersectsExtent(extent);
    }

    public getClosestCoordinates(point: Coordinate) {
        return this.geometry.getClosestPoint(point);
    }

    public getSingleGeometry() {
        return new Point(this.geometry.getCoordinates()[0]);
    }

    public insertGeometry(geometry: Geometry, path: number[]): number[] | undefined {
        if (geometry instanceof Point) {
            const position = GeometryExtensionUtilities.getPositionFromPath1(path);
            this.setCoordinates(GeometryExtensionUtilities.modifyPointInLine(position, this.getCoordinates() ?? [], geometry.getCoordinates()));
            return position;
        }
        return undefined
    }

    public replaceGeometry(geometry: Geometry, path: number[]): number[] | undefined {
        if (geometry instanceof MultiPoint) {
            this.setCoordinates(geometry.getCoordinates().slice())
            return [];
        }
        else if (geometry instanceof Point) {
            const position = GeometryExtensionUtilities.getPositionFromPath1(path);
            this.setCoordinates(GeometryExtensionUtilities.modifyPointInLine(position, this.getCoordinates() ?? [], geometry.getCoordinates(), true));
            return position;
        }
        return undefined
    }

    public removeGeometry(path: number[]): number[] | undefined {
        const coords = this.getCoordinates() ?? [];
        if (path.length >= 1 && coords[path[0]]) {
            const position = GeometryExtensionUtilities.getPositionFromPath1(path);
            this.setCoordinates(GeometryExtensionUtilities.modifyPointInLine(position, coords));
            return position;
        }
        return undefined;
    }

    public canRemove(path: number[]): boolean {
        const coords = this.getCoordinates() ?? [];
        return path.length >= 1 && coords.length > 1 && coords[path[0]] !== undefined;
    }

    public groupSectionsAtDateLine() {
        const coords = this.geometry.getCoordinates().map(coordinate => {
            if (GeometryExtensionUtilities.shouldWrapLongitude(coordinate[0])) {
                let longitude = DateLineUtilities.setBetweenDateLines(coordinate[0]);
                coordinate[0] = DateLineUtilities.translateX(longitude, 1);
            }
            return coordinate;
        })

        this.setCoordinates(coords);
    }

    public mergeSnappedPoints() {
        //Note: merging multipoint is not necessary
        //const coords = this.getCoordinates();        
        //const merged = GeometryExtensionUtilities.mergeSnappedPoints(coords);
        //if (merged) {
        //    this.setCoordinates(merged);
        //    return true;
        //}        
        return false;
    }
}
